module.exports = __webpack_public_path__ + "static/img/jindan.9652c58b.png";